.hero {
  --journey-scrim-x: -28px;
  --journey-scrim-y: -16px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary) 55%, var(--color-primary-deep));
  border-radius: 16px;
  color: var(--color-text-on-primary);
  isolation: isolate;
  overflow: hidden;
  padding: 24px 32px 28px;
  position: relative;
}

/* The text lies over the band and the soft field. */
.hero > :not([aria-hidden]) {
  position: relative;
  z-index: 1;
}

.back {
  color: var(--color-text-on-primary);
  font-size: var(--font-size-small);
  opacity: 0.85;
  text-decoration: none;
}

.back:hover,
.back:focus-visible {
  opacity: 1;
  text-decoration: underline;
}

.badge {
  /* Opaque, so the band behind it never meets the white text. */
  background: var(--color-primary-deep);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  color: var(--color-text-on-primary);
  display: block;
  font-size: var(--font-size-small);
  margin: 16px 0 0;
  padding: 2px 12px;
  width: fit-content;
}

.heading {
  color: var(--color-text-on-primary);
  font-family: var(--font-family-heading);
  margin: 8px 0;
  overflow-wrap: anywhere;
}

/* The heading in the help box under the title, white like the rest of the box. */
.hero h3 {
  color: inherit;
}

.facts {
  color: var(--color-text-on-primary-soft);
  display: flex;
  flex-wrap: wrap;
  font-size: var(--font-size-small);
  gap: 4px 24px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.meta {
  color: var(--color-text-on-primary-soft);
  font-size: var(--font-size-small);
  margin: 8px 0 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.actions:empty {
  display: none;
}

.primary,
.secondary {
  border-radius: 999px;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-small);
  padding: 10px 20px;
  text-decoration: none;
}

.primary {
  background: var(--color-cta);
  border: 1px solid var(--color-cta);
  color: var(--color-primary-deep);
  font-weight: 400;
}

.secondary {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: var(--color-text-on-primary);
}

.secondary[aria-pressed="true"] {
  background: rgba(255, 255, 255, 0.15);
}

.primary:focus-visible,
.secondary:focus-visible,
.back:focus-visible {
  outline: 3px solid var(--color-accent);
  outline-offset: 2px;
}

@media (max-width: 599px) {
  .hero {
    padding: 20px 16px 24px;
  }
}
